import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { getRuntimeConfig } from "../config/runtime-config";
import { authSlice } from "./slices/authSlice";
import { serviceSlice } from "./slices/serviceSlice";
import { uiSlice } from "./slices/uiSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "service"], // Only persist auth and service state
};

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  service: serviceSlice.reducer,
  ui: uiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const runtimeConfig = getRuntimeConfig();

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/PURGE"],
      },
    }),
  devTools: runtimeConfig.nodeEnv !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
